import AxiosInstance from '../../helpers/axios-instance/axios-instance';
import { appConfig } from '../../helpers/app-config/app-config';
import type { UserInfo } from './user-client.type';

const axiosInstance = AxiosInstance();
const baseURL = appConfig.VITE_APP_API_URL + '/auth/';

/**
 * Method to edit the user records
 *
 * @param body a full or partial object of UserInfo
 * @returns a updated object of UserInfo
 */
function editMe(body: Partial<UserInfo>): Promise<UserInfo> {
  const apiURL = baseURL + 'users/me/';

  return axiosInstance
    .put<any>(apiURL, body)
    .then((response) => response.data)
    .catch((error) => error.response);
}

/**
 * Method to fetch the user info
 *
 * @returns a object of UserInfo
 */
const fetchUserInfo = (): Promise<UserInfo> => {
  const apiURL = baseURL + 'users/me/';
  return axiosInstance
    .get<UserInfo>(apiURL)
    .then((response) => response.data)
    .catch((error) => Promise.reject({ error: error.response.data }));
};

export { editMe, fetchUserInfo };
